import { render, staticRenderFns } from "./OnlineMenu.vue?vue&type=template&id=0eec251b&"
import script from "./OnlineMenu.vue?vue&type=script&lang=js&"
export * from "./OnlineMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports